/*
 * Twenty Eight Unity — thème Shopify.
 * Porté du prototype : intro, ciel de nuages, header, landing, pièces
 * (tailles = variantes Shopify) et panier (API panier Shopify).
 */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var prefersReducedMotion = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var root = document.documentElement;
  var theme = window.theme || { routes: {} };
  var routes = theme.routes || {};
  var url = function (path) { return (routes.root || '/').replace(/\/$/, '') + path; };

  /* ================= PRIX =================
   * Format du site, identique au snippet price.liquid : « 35 € », « 35,50 € ».
   */
  function formatMoney(cents) {
    var value = Number(cents) || 0;
    var decimals = value % 100 === 0 ? 0 : 2;
    var parts = (value / 100).toFixed(decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (parts[1] ? whole + ',' + parts[1] : whole) + ' €';
  }

  /* ================= INTRO (fin) =================
   * L'approche est en CSS (assets/intro.css) et démarre au premier rendu.
   * Ici : fin de l'approche → maintien → révélation (le noir s'efface sur le
   * ciel, le symbole se pose sur celui de la landing). Tap / Échap : révélation directe.
   */
  var HOLD = 160;
  var REVEAL = 520;
  var EASE = 'cubic-bezier(.65, 0, .35, 1)';

  function flip(from, to) {
    var a = from.getBoundingClientRect();
    var b = to.getBoundingClientRect();
    var scale = b.width / a.width;
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    return 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ')';
  }

  function playIntro() {
    var el = document.getElementById('intro');
    if (!el) return Promise.resolve(false);
    var stage = $('.intro__stage', el);
    var face = $('.intro__face', el);
    var reduce = prefersReducedMotion();

    return new Promise(function (resolve) {
      var started = false;
      var onSkip = function () { reveal(true); };
      var onKey = function (e) { if (['Escape', 'Enter', ' '].indexOf(e.key) !== -1) reveal(true); };

      function reveal(fast) {
        if (started) return;
        started = true;
        window.removeEventListener('keydown', onKey);
        el.removeEventListener('click', onSkip);

        var target = $('[data-landing-logo]');
        var glide = Boolean(target) && !fast && !reduce && !!el.animate;
        var duration = fast ? 260 : REVEAL;

        el.style.pointerEvents = 'none';
        root.classList.remove('is-intro');
        if (glide) root.classList.add('intro-landing');
        resolve(true);

        var done = function () {
          root.classList.remove('intro-landing');
          // Le symbole de la page (finition or rose) apparaît sous celui de
          // l'intro, qui s'efface en fondu : pas de changement de teinte brusque.
          if (glide && stage.animate) {
            stage.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 320, easing: EASE, fill: 'forwards' })
              .finished.catch(function () {}).then(function () { el.remove(); });
          } else {
            el.remove();
          }
        };
        if (!el.animate) { done(); return; }
        if (glide) stage.animate([{ transform: 'none' }, { transform: flip(face, target) }], { duration: duration, easing: EASE, fill: 'forwards' });
        else stage.animate([{ opacity: 1 }, { opacity: 0 }], { duration: duration, easing: EASE, fill: 'forwards' });
        el.animate(
          [{ backgroundColor: 'rgba(10, 10, 10, 1)' }, { backgroundColor: 'rgba(10, 10, 10, 0)' }],
          { duration: duration, easing: EASE, fill: 'forwards' }
        ).finished.catch(function () {}).then(done);
      }

      el.addEventListener('click', onSkip);
      window.addEventListener('keydown', onKey);

      if (reduce) { setTimeout(function () { reveal(); }, 500); return; }
      var depth = $('.intro__depth', el);
      var approach = depth && depth.getAnimations ? depth.getAnimations()[0] : null;
      (approach ? approach.finished : Promise.resolve())
        .catch(function () {})
        .then(function () { setTimeout(function () { reveal(); }, HOLD); });
    });
  }

  /* ================= CIEL (WebGL) =================
   * Trois couches de nuages sombres (bruit fractal à domaine déformé),
   * mouvement continu sans point de boucle. Démarré après le premier rendu.
   */
var VERT = `
attribute vec2 a_pos;
void main() { gl_Position = vec4(a_pos, 0.0, 1.0); }
`;

var FRAG = `
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
uniform vec2 u_res;
uniform float u_time;

float hash(vec2 p) {
  p = fract(p * vec2(123.34, 456.21));
  p += dot(p, p + 45.32);
  return fract(p.x * p.y);
}

float noise(vec2 p) {
  vec2 i = floor(p);
  vec2 f = fract(p);
  vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x),
             mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);
}

float fbm(vec2 p) {
  float v = 0.0;
  float a = 0.5;
  mat2 rot = mat2(0.8, 0.6, -0.6, 0.8);
  for (int i = 0; i < 5; i++) {
    v += a * noise(p);
    p = rot * p * 2.02 + 17.0;
    a *= 0.5;
  }
  return v;
}

// Une couche de nuages : fbm déformé par lui-même (volutes de fumée).
float layer(vec2 p, float t, vec2 drift) {
  vec2 q = p + drift * t;
  vec2 w = vec2(fbm(q + vec2(0.0, t * 0.05)), fbm(q + vec2(5.2, 1.3) - vec2(t * 0.04, 0.0)));
  return fbm(q + 1.7 * w);
}

void main() {
  vec2 uv = gl_FragCoord.xy / u_res.y;
  float t = u_time;
  vec2 drift = vec2(1.0, 0.16); // horizontal, légèrement diagonal

  float far  = layer(uv * 1.6 + 3.0,  t * 0.010, drift);
  float mid  = layer(uv * 2.6 + 11.0, t * 0.017, drift);
  float near = layer(uv * 1.1 + 7.0,  t * 0.026, drift);

  // Contraste marqué entre masses nuageuses et ciel noir (volutes lisibles).
  float d = smoothstep(0.38, 0.72, far)  * 0.45
          + smoothstep(0.42, 0.78, mid)  * 0.30
          + smoothstep(0.40, 0.75, near) * 0.55;
  d = pow(clamp(d, 0.0, 1.0), 1.2);

  // Reste très sombre : au plus ~27 % de luminance au cœur des nuages.
  float shade = 0.030 + d * 0.26;

  // Vignette douce : les bords plus sombres.
  vec2 c = gl_FragCoord.xy / u_res - 0.5;
  shade *= 1.0 - dot(c, c) * 0.7;

  // Léger tramage contre le banding.
  shade += (hash(gl_FragCoord.xy + t) - 0.5) / 255.0;

  gl_FragColor = vec4(vec3(shade), 1.0);
}
`;

var RESOLUTION = 0.5; // fraction des pixels CSS

  function mountSky() {
    var canvas = document.createElement('canvas');
    canvas.className = 'sky';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(canvas, document.body.firstChild);

    var gl = canvas.getContext('webgl', { antialias: false, alpha: false, powerPreference: 'low-power' });
    if (!gl) { canvas.remove(); return; }

    var compile = function (type, src) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, src);
      gl.compileShader(shader);
      return shader;
    };
    var parallel = gl.getExtension('KHR_parallel_shader_compile');
    var program = gl.createProgram();
    gl.attachShader(program, compile(gl.VERTEX_SHADER, VERT));
    gl.attachShader(program, compile(gl.FRAGMENT_SHADER, FRAG));
    gl.linkProgram(program);

    (function whenLinked() {
      if (parallel && !gl.getProgramParameter(program, parallel.COMPLETION_STATUS_KHR)) {
        requestAnimationFrame(whenLinked);
        return;
      }
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        console.warn('Ciel désactivé :', gl.getProgramInfoLog(program));
        canvas.remove();
        return;
      }
      runSky(gl, canvas, program);
    })();
  }

  function runSky(gl, canvas, program) {
    gl.useProgram(program);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var pos = gl.getAttribLocation(program, 'a_pos');
    gl.enableVertexAttribArray(pos);
    gl.vertexAttribPointer(pos, 2, gl.FLOAT, false, 0, 0);
    var uRes = gl.getUniformLocation(program, 'u_res');
    var uTime = gl.getUniformLocation(program, 'u_time');

    var resize = function () {
      var w = Math.max(1, Math.round(window.innerWidth * RESOLUTION));
      var h = Math.max(1, Math.round(window.innerHeight * RESOLUTION));
      if (canvas.width === w && canvas.height === h) return;
      canvas.width = w;
      canvas.height = h;
      gl.viewport(0, 0, w, h);
      gl.uniform2f(uRes, w, h);
    };
    // Horloge du ciel partagée entre les pages (sessionStorage) : Shopify
    // recharge la page à chaque navigation, les nuages reprennent là où ils
    // en étaient au lieu de repartir d'un point au hasard.
    var clock = null;
    try { clock = JSON.parse(sessionStorage.getItem('28u.sky') || 'null'); } catch (e) {}
    if (!clock || typeof clock.seed !== 'number') {
      clock = { seed: Math.random() * 500, t0: Date.now() };
      try { sessionStorage.setItem('28u.sky', JSON.stringify(clock)); } catch (e) {}
    }
    // Vitesse des nuages : 1.22 = +22 % par rapport à la version précédente.
    var SKY_SPEED = 1.22;
    var skyTime = function () { return (clock.seed + (Date.now() - clock.t0) / 1000) * SKY_SPEED; };
    var draw = function (seconds) {
      resize();
      gl.uniform1f(uTime, seconds);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    };
    var raf = 0;
    var loop = function () { draw(skyTime()); raf = requestAnimationFrame(loop); };
    var start = function () {
      cancelAnimationFrame(raf);
      if (prefersReducedMotion()) draw(clock.seed);
      else raf = requestAnimationFrame(loop);
    };
    window.addEventListener('resize', function () { if (prefersReducedMotion()) draw(clock.seed); });
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.addEventListener) mq.addEventListener('change', start);
    start();
    if (document.getElementById('intro')) canvas.classList.add('is-ready');
    else requestAnimationFrame(function () { canvas.classList.add('is-ready'); });
  }

  /* ================= APPARITIONS ================= */
  function observeReveals(scope) {
    var els = $$('[data-reveal]:not(.is-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ================= PANIER (API Shopify) ================= */
  var drawer;
  var lastFocus;
  var cartState = null;

  function request(path, body) {
    return fetch(url(path), {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Erreur panier');
        return data;
      });
    });
  }

  function setCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      if (el.textContent !== String(count)) {
        el.textContent = count;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
  }

  function thumb(src) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '240');
      return u.toString();
    } catch (e) { return src; }
  }

  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  // Photo détourée livrée avec le thème (window.theme.cutouts), sinon photo du produit.
  function cutout(item) {
    var map = theme.cutouts || {};
    return map[item.handle] || thumb(item.image);
  }

  function lineTemplate(item) {
    var size = item.product_has_only_default_variant ? 'Taille unique' : 'Taille ' + escapeHtml(item.variant_title);
    return '' +
      '<li class="cart-line" data-key="' + escapeHtml(item.key) + '">' +
        '<a class="cart-line__media" href="' + escapeHtml(item.url) + '">' +
          (cutout(item) ? '<img src="' + escapeHtml(cutout(item)) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-line__info">' +
          '<div class="cart-line__top">' +
            '<a class="cart-line__name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            '<span>' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<p class="cart-line__meta">' + size + '</p>' +
          '<div class="cart-line__bottom">' +
            '<div class="qty" role="group" aria-label="Quantité">' +
              '<button type="button" data-qty="-1" aria-label="Retirer un">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty="1" aria-label="Ajouter un">+</button>' +
            '</div>' +
            '<button type="button" class="link-btn" data-remove>Retirer</button>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function renderCart(cart) {
    cartState = cart;
    setCount(cart.item_count);
    if (!drawer) return;
    var body = $('.drawer__body', drawer);
    var foot = $('.drawer__foot', drawer);
    $('.drawer__count', drawer).textContent = '(' + cart.item_count + ')';
    if (!cart.items.length) {
      body.innerHTML =
        '<div class="drawer__empty">' +
          '<p>Ton panier est vide.</p>' +
          '<a class="line-btn" href="' + (routes.drop || url('/collections/all')) + '">Premier drop</a>' +
        '</div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = '<ul class="cart-lines">' + cart.items.map(lineTemplate).join('') + '</ul>';
    foot.hidden = false;
    $('.drawer__subtotal', drawer).textContent = formatMoney(cart.total_price);
  }

  function notice(message) {
    var el = drawer && $('.drawer__notice', drawer);
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function refreshCart() { return request('/cart.js').then(renderCart); }

  function openCart() {
    if (!drawer) { location.href = routes.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    root.classList.add('cart-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    requestAnimationFrame(function () { $('.drawer__close', drawer).focus(); });
  }

  function closeCart() {
    root.classList.remove('cart-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    notice('');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function addToCart(variantId) {
    return request('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] }).then(refreshCart);
  }

  function mountCart() {
    drawer = $('.drawer');
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-close]')) return closeCart();
      var line = t.closest('.cart-line');
      if (!line || !cartState) return;
      var key = line.getAttribute('data-key');
      var item = cartState.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      var qtyBtn = t.closest('[data-qty]');
      var next = null;
      if (qtyBtn) next = item.quantity + Number(qtyBtn.getAttribute('data-qty'));
      if (t.closest('[data-remove]')) { next = 0; line.classList.add('is-removing'); }
      if (next === null) return;
      notice('');
      request('/cart/change.js', { id: key, quantity: Math.max(0, next) })
        .then(renderCart)
        .catch(function (err) { notice(err.message); refreshCart(); });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('cart-open')) closeCart();
    });
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        setMenu(false);
        openCart();
      });
    });
    refreshCart().catch(function () {});
  }

  /* ================= HEADER / MENU ================= */
  var menu, toggle;
  function setMenu(open) {
    if (!menu || !toggle) return;
    root.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    $('.nav__menu-label', toggle).textContent = open ? 'Fermer' : 'Menu';
    menu.setAttribute('aria-hidden', String(!open));
    menu.inert = !open;
  }

  function mountNav() {
    menu = $('#menu');
    toggle = $('.nav__menu');
    if (!menu || !toggle) return;
    setMenu(false);
    toggle.addEventListener('click', function () { setMenu(!root.classList.contains('menu-open')); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target) && !toggle.contains(e.target)) setMenu(false);
    });

    var header = $('.nav');
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-hidden', y > 300 && y > lastY && !root.classList.contains('menu-open'));
      lastY = y;
    }, { passive: true });
  }

  /* ================= LANDING ================= */
  function openDialog(dialog) {
    if (!dialog) return;
    if (dialog.showModal && !dialog.open) dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function mountDialog(dialog, openSel, closeSel) {
    if (!dialog) return;
    $$(openSel).forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDialog(dialog);
        var input = $('input[type="email"], input[type="password"]', dialog);
        if (input) setTimeout(function () { input.focus(); }, 50);
      });
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest(closeSel)) dialog.close ? dialog.close() : dialog.removeAttribute('open');
    });
  }

  function mountLanding(introRunning) {
    var poster = $('.poster:not(.poster--static)');
    if (!poster) return;

    var signup = $('#signup');
    mountDialog(signup, '[data-signup-open]', '[data-signup-close]');
    mountDialog($('#password'), '[data-password-open]', '[data-password-close]');
    // Inscription : e-mail vérifié avant l'envoi à Shopify (message lisible, focus sur le champ).
    var signupForm = signup && $('form', signup);
    var email = signupForm && $('input[type="email"]', signupForm);
    if (email) {
      var msg = $('.signup-drop__msg', signupForm);
      signupForm.addEventListener('submit', function (e) {
        email.value = email.value.trim();
        if (email.value && email.checkValidity()) return;
        e.preventDefault();
        email.setAttribute('aria-invalid', 'true');
        if (msg) msg.textContent = email.value ? 'Adresse e-mail invalide.' : 'Saisis ton adresse e-mail.';
        email.focus();
      });
      email.addEventListener('input', function () {
        if (!email.hasAttribute('aria-invalid')) return;
        email.removeAttribute('aria-invalid');
        if (msg) msg.textContent = '';
      });
    }
    // Retour du formulaire Shopify : on rouvre la fenêtre sur le message.
    var reopen = $('[data-signup-success], [data-signup-error]', signup || document);
    var passwordError = $('[data-password-error]');

    var show = function () {
      document.body.classList.add('poster-in');
      if (reopen) openDialog(signup);
      if (passwordError) openDialog($('#password'));
      if (prefersReducedMotion() || reopen || passwordError) return;
      var year = $('[data-year]', poster);
      if (!year) return;
      var to = parseInt(year.getAttribute('data-year-to'), 10);
      if (!to || to < 1996) return;
      var t0 = performance.now();
      var step = function (now) {
        var t = Math.min((now - t0) / 900, 1);
        year.textContent = String(Math.round(1996 + (1 - Math.pow(1 - t, 3)) * (to - 1996)));
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (introRunning) window.addEventListener('intro:done', show, { once: true });
    else {
      document.body.classList.add('poster-fade');
      requestAnimationFrame(show);
    }
  }

  /* ================= PIÈCES (tailles + ajout au panier) ================= */
  var LABEL_SELECT = 'Sélectionner la taille';
  var LABEL_ADD = 'Ajouter au panier';

  function mountPieces() {
    var pieces = $$('.piece');
    if (!pieces.length) return;

    var setExpanded = function (el, open) {
      var btn = $('[data-action]', el);
      btn.setAttribute('aria-expanded', String(open));
      el.classList.toggle('is-open', open);
      $$('.piece__size', el).forEach(function (s) { s.tabIndex = open ? 0 : -1; });
    };
    var hint = function (el, text) { var h = $('.piece__hint', el); if (h) h.textContent = text || ''; };

    var add = function (el, btn, variantId) {
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      hint(el, '');
      var label = $('[data-label]', btn);
      var previous = label.textContent;
      addToCart(variantId).then(function () {
        btn.classList.add('is-done');
        label.textContent = 'Ajouté';
        setTimeout(function () { btn.classList.remove('is-done'); label.textContent = previous; }, 1300);
        openCart();
      }).catch(function (err) {
        hint(el, err.message);
      }).then(function () { btn.classList.remove('is-busy'); });
    };

    document.addEventListener('click', function (e) {
      var el = e.target.closest('.piece');
      if (!el) return;

      var size = e.target.closest('.piece__size');
      if (size) {
        if (size.getAttribute('aria-disabled') === 'true') { hint(el, size.getAttribute('data-size') + ' épuisé.'); return; }
        hint(el, '');
        el.setAttribute('data-variant', size.getAttribute('data-variant'));
        $$('.piece__size', el).forEach(function (s) { s.setAttribute('aria-checked', String(s === size)); });
        el.classList.add('has-size');
        $('[data-label]', el).textContent = LABEL_ADD + ' — ' + size.getAttribute('data-size');
        return;
      }

      var btn = e.target.closest('[data-action]');
      if (!btn || btn.disabled) return;
      if (btn.hasAttribute('data-variant')) return add(el, btn, btn.getAttribute('data-variant'));
      if (el.getAttribute('data-variant')) return add(el, btn, el.getAttribute('data-variant'));
      setExpanded(el, !el.classList.contains('is-open'));
      if (el.classList.contains('is-open')) {
        var first = $('.piece__size:not([aria-disabled="true"])', el) || $('.piece__size', el);
        if (first) first.focus({ preventScroll: true });
      }
    });

    document.addEventListener('keydown', function (e) {
      var size = e.target.closest && e.target.closest('.piece__size');
      if (!size || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      var all = Array.prototype.slice.call(size.parentElement.children);
      var next = all[(all.indexOf(size) + (e.key === 'ArrowRight' ? 1 : -1) + all.length) % all.length];
      next.focus();
      e.preventDefault();
    });
  }

  /* ================= TRANSITIONS DE PAGE =================
   * Comme dans le prototype : la page sort en fondu, la suivante entre en
   * fondu + léger glissement (styles body.is-leaving / is-entering de base.css).
   * Checkout, compte et modifications du panier partent sans attendre.
   */
  function mountPageTransitions(introRunning) {
    if (prefersReducedMotion()) return;
    if (!introRunning) {
      document.body.classList.add('is-entering');
      setTimeout(function () { document.body.classList.remove('is-entering'); }, 700);
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
      var dest = new URL(a.href, location.href);
      if (dest.origin !== location.origin) return;
      if (dest.pathname === location.pathname && dest.search === location.search) return;
      if (/^\/(checkout|account|cart\/(change|add|clear|update))/.test(dest.pathname)) return;
      e.preventDefault();
      document.body.classList.add('is-leaving');
      setTimeout(function () { location.href = dest.href; }, 300);
    });
    // Retour arrière (cache du navigateur) : la page doit réapparaître.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) document.body.classList.remove('is-leaving');
    });
  }

  /* ================= LOGO 3D — ROTATION HORIZONTALE =================
   * Seul le symbole pivote, et uniquement autour de l'axe vertical (gauche ↔
   * droite) ; la signature et « Loading 2027. » ne bougent jamais.
   * Pendant le geste : la rotation suit le doigt / la souris, amplifiée selon
   * la vitesse du geste (lent = précis, rapide = plus ample), avec un lissage
   * court. À la fin de CHAQUE geste : retour fluide et automatique à 0°, par
   * le chemin le plus court — l'angle n'est jamais mémorisé.
   * Clavier : ← / → font pivoter, retour à 0° au relâchement.
   * reduced-motion : suivi direct, retour à 0° immédiat.
   */
  function mountLogo3D() {
    var el = $('[data-logo3d]');
    var obj = el && $('.logo3d', el);
    if (!obj) return;
    var cur = 0;          // angle affiché (degrés)
    var tgt = 0;          // angle visé
    var returning = false;
    var raf = 0;
    var drag = null;
    var keyTimer = 0;
    var rad = Math.PI / 180;

    var apply = function () {
      obj.style.setProperty('--ry', cur.toFixed(2) + 'deg');
      var sy = Math.sin(cur * rad);
      var facing = Math.cos(cur * rad);
      obj.style.setProperty('--sheen-x', (50 - sy * 90).toFixed(1) + '%');
      obj.style.setProperty('--sheen-o', facing > 0 ? (Math.abs(sy) * 0.4 * facing).toFixed(3) : '0');
      obj.style.setProperty('--light-x', (34 - sy * 30).toFixed(1) + '%');
    };
    // Lissage en fonction du temps (identique à 30, 60 ou 120 images/s) :
    // suivi quasi immédiat pendant le geste (constante 45 ms), retour à 0°
    // doux et amorti (constante 130 ms ≈ 0,6 s au total).
    var last = 0;
    var tick = function (now) {
      var dt = last ? Math.min(64, now - last) : 16;
      last = now;
      var tau = returning ? 130 : 45;
      cur += (tgt - cur) * (1 - Math.exp(-dt / tau));
      if (Math.abs(tgt - cur) < 0.04) {
        cur = tgt;
        raf = 0;
        last = 0;
        if (returning && tgt === 0) returning = false;
      } else {
        raf = requestAnimationFrame(tick);
      }
      apply();
    };
    var kick = function () {
      if (prefersReducedMotion()) { cur = tgt; apply(); return; }
      if (!raf) raf = requestAnimationFrame(tick);
    };
    var returnHome = function () {
      // Ramène l'angle dans ]-180°, 180°] (même position visuelle), puis vise 0°.
      cur = ((cur % 360) + 540) % 360 - 180;
      tgt = 0;
      returning = true;
      kick();
    };

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      returning = false;
      tgt = cur;
      drag = { id: e.pointerId, x: e.clientX, t: performance.now(), k: 360 / Math.max(120, el.clientWidth * 1.5) };
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      el.classList.add('is-dragging');
      if (e.pointerType === 'mouse') e.preventDefault();
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var now = performance.now();
      var dx = e.clientX - drag.x;
      var speed = Math.abs(dx) / Math.max(8, now - drag.t);          // px / ms
      var gain = 1 + Math.min(speed, 2.5) * 0.45;                     // lent ≈ 1, rapide ≤ 2,1
      tgt += dx * drag.k * gain;
      drag.x = e.clientX;
      drag.t = now;
      kick();
    });
    var end = function (e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      drag = null;
      el.classList.remove('is-dragging');
      returnHome();
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('lostpointercapture', end);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('keydown', function (e) {
      var step = { ArrowLeft: -20, ArrowRight: 20 }[e.key];
      if (!step) return;
      returning = false;
      tgt += step;
      kick();
      clearTimeout(keyTimer);
      keyTimer = setTimeout(returnHome, 450);
      e.preventDefault();
    });
    el.addEventListener('blur', function () { if (!drag && cur !== 0) returnHome(); });
    apply();
  }

  /* ================= DÉMARRAGE ================= */
  var introRunning = root.classList.contains('is-intro');
  // Le ciel démarre juste après le premier rendu pour ne jamais retarder l'intro.
  requestAnimationFrame(function () { requestAnimationFrame(mountSky); });
  mountPageTransitions(introRunning);
  mountNav();
  mountCart();
  mountLanding(introRunning);
  mountLogo3D();
  mountPieces();
  observeReveals(document);
  playIntro().then(function () { window.dispatchEvent(new Event('intro:done')); });
})();
